// @todo проверить, нужен ли этот eslint-disable
/* eslint-disable react-hooks/exhaustive-deps */

import {
  Button,
  Panel,
  PanelHeader,
  Text,
  Snackbar,
  Avatar,
  ScreenSpinner,
} from "@vkontakte/vkui";
import React, { useEffect, useRef, useState } from "react";
import { isBefore, parseISO } from "date-fns";
import Div from "@vkontakte/vkui/dist/components/Div/Div";
import Icon24CheckCircleOn from "@vkontakte/icons/dist/24/check_circle_on";
import { connect } from "react-redux";
import styles from "./EqueuesPanel.style";
import {
  equeuesLoadingStarted,
  setExceptions as setExceptionsAction,
} from "../../redux/actions/equeuesActions";
import { setActivePanel } from "../../redux/actions/panelsActions";
import { panels } from "../../variables";
import Header from "../Header";
import DoneEqueuesList from "./DoneEqueuesList/DoneEqueuesList";
import EmptyEqueuesListMessage from "./EmptyEqueuesListMessage";
import { selectEqueue } from "../../redux/actions/selectedEqueueAction";
import UserAvatar from "../UserAvatar";
import {
  hideEqueuesSnackBar,
  showEqueuesSnackBar,
} from "../../redux/actions/snackbarsActions";
import EqueuesList from "./EqueuesList/EqueuesList";
import { selectSlot } from "../../redux/actions/datesActions";
import {
  hideQueuesLoader,
  showQueuesLoader,
} from "../../redux/actions/loaderActions";
import ConfirmLogoutAlert from "../../alerts/ConfirmLogoutAlert";
import { setActiveAlert } from "../../redux/actions/alertsActions";
import { cleanNameSelector } from "../../redux/actions/doctorsActions";
import { restartSteps } from "../../redux/actions/regionAndMedicalOrganisationActions";
import { sortQueque } from "../../helpers/sortQueque";
import HeaderWithLogout from "../../components/HeaderWithLogout/HeaderWithLogout";
import {setMetrics} from "../../helpers/metrics";

const EqueuesPanel = ({
  id,
  startLoadingEqueues,
  items,
  success,
  selectEqueue,
  goToSelectedEqueuePanel,
  showSnackBar,
  hideSnackBar,
  selectedSlot,
  clearSlot,
  showQueuesLoader,
  setEqueuesLoaderVisible,
  goToDefaultScenarioPage,
  showEqueueSnackBar,
  hideEqueuesLoader,
  setExceptionsEqueue,
}) => {
  const [snackBar, setSnackBar] = useState(null);
  const [showButton, setShowButton] = useState(false);

  const intervalRef = useRef(null);

  useEffect(() => {
    setTimeout(() => {
      setShowButton(true);
    }, 400);

    return () => {
      setSnackBar(null);
      hideSnackBar();
      clearSlot();
    }
  }, []);

  useEffect(() => {
    setEqueuesLoaderVisible();
    startLoadingEqueues();
  }, [setEqueuesLoaderVisible, startLoadingEqueues]);

  useEffect(() => {
    if (
      success &&
      items.length &&
      showSnackBar &&
      findLastEqueueId(items, selectedSlot) > 0
    ) {
      if (!snackBar) {
        setSnackBar(
          <Snackbar
            onClose={() => {
              setSnackBar(null);
              hideSnackBar();
              clearSlot();
            }}
            action="Посмотреть"
            onActionClick={() => {
              selectEqueue(findLastEqueueId(items, selectedSlot));
              goToSelectedEqueuePanel();
              setShowButton(false);
            }}
            before={
              <Avatar size={24}>
                <Icon24CheckCircleOn fill="#06844D" />
              </Avatar>
            }
          >
            Запись к врачу создана
          </Snackbar>
        );
      }
      hideSnackBar();
    } else if (
      success &&
      items.length &&
      showSnackBar &&
      findLastEqueueId(items, selectedSlot) < 0
    ) {
      if (!snackBar) {
        setSnackBar(
          <Snackbar
            onClose={() => {
              setSnackBar(null);
              hideSnackBar();
              clearSlot();
            }}
            onActionClick={() => {
              selectEqueue(findLastEqueueId(items, selectedSlot));
              goToSelectedEqueuePanel();
              setShowButton(false);
            }}
            before={
              <Avatar size={24}>
                <Icon24CheckCircleOn fill="#06844D" />
              </Avatar>
            }
          >
            Запись к врачу создана
          </Snackbar>
        );
      }
      hideSnackBar();
    }

    if (success && findLastEqueueId(items, selectedSlot) > 0) {
      setEqueuesLoaderVisible();
      intervalRef.current = setInterval(() => {
        startLoadingEqueues();
      }, 200);
    }
    if (success && findLastEqueueId(items, selectedSlot) >= 0) {
      showEqueueSnackBar();
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
      hideEqueuesLoader();
    }
  }, [success, items, showSnackBar]);


  const splitEqueuesIntoTwoGroups = (equeues = []) => {
    const activeEqueues = [];
    const history = [];
    for (let index = 0; index < equeues.length; index++) {
      const equeue = equeues[index];
      if (equeue.status === "done" && isEqueueActual(equeue)) {
        activeEqueues.push(equeue);
      } else {
        history.push({ ...equeue, status: "reject" });
      }
    }
    if (activeEqueues.length) {
      const exceptions = activeEqueues.map((item) =>
        new Date(item.data.snippets[0].localDate).getTime()
      );
      setExceptionsEqueue(exceptions);
    }
    return [activeEqueues.sort(sortQueque), history.sort(sortQueque)];
  };

  const isEqueueActual = (equeue) => {
    const equeueTime = parseISO(equeue.date);
    const now = new Date();
    return isBefore(now, equeueTime);
  };
  const [doneEqueues, otherEqueues] = splitEqueuesIntoTwoGroups(items);

  const findLastEqueueId = (equeues, lastSelectedSlot) => {
    if (!equeues || !lastSelectedSlot) {
      return 0;
    }
    for (let i = 0; i < equeues.length; i++) {
      const currentEqueueTime = new Date(equeues[i].data.snippets[0].localDate);
      const lastSelectedSlotTime = new Date(lastSelectedSlot.visitTimeStr);
      if (currentEqueueTime.getTime() === lastSelectedSlotTime.getTime()) {
        return equeues[i].id;
      }
    }
    return -1;
  };
  const isEqueues = doneEqueues?.length || otherEqueues?.length;

  useEffect(() => setMetrics('reachGoal','OldHealth.BookingList'), [])



  return (
    <Panel id={id}
    >
      <PanelHeader
        separator={false}
        style={{
          padding: "0",
        }}
        left={
          <Div
            style={{
              display: "flex",
              padding: "0",
            }}
          >
            <HeaderWithLogout />
          </Div>
        }
      />
      {isEqueues ? (
        <div
          style={{
            ...styles.orderButtonContainer,
          }}
        >
          <Button
            size="l"
            style={{...styles.orderButton, visibility: showButton && 'visible'}}
            onClick={() => {
              setShowButton(false);
              goToDefaultScenarioPage();
            }}
          >
            Записаться к врачу
          </Button>
        </div>
      ) : null}
      <div style={styles.container}>
        <Text style={styles.headerText} weight="regular">
          Записи к врачу
        </Text>
        {isEqueues ? (
          <>
            <DoneEqueuesList items={doneEqueues} />
            <EqueuesList items={otherEqueues} />
            {snackBar}
          </>
        ) : showQueuesLoader ? (
          <Div style={{ marginTop: "10vh" }}>
            <ScreenSpinner />
          </Div>
        ) : (
          <EmptyEqueuesListMessage />
        )}
      </div>
    </Panel>
  );
};

const mapStateToProps = (state) => {
  const { accessToken, expiresIn } = state.user;
  const { showQueuesLoader } = state.loader;
  const { items } = state.equeues;
  const { success } = state.equeues;
  const { showEqueuesSnackBar } = state.snackBars;
  const { selectedSlot } = state.dates;
  return {
    accessToken,
    expiresIn,
    showQueuesLoader,
    items,
    success,
    showSnackBar: showEqueuesSnackBar,
    selectedSlot,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    startLoadingEqueues: () => dispatch(equeuesLoadingStarted()),
    goToDefaultScenarioPage: () => {
      dispatch(restartSteps());
      dispatch(cleanNameSelector());
      dispatch(setActivePanel(panels.regionAndMedicalOrganisation));
    },
    selectEqueue: (id) => dispatch(selectEqueue(id)),
    goToSelectedEqueuePanel: () =>
      dispatch(setActivePanel(panels.selectedEqueue)),
    hideSnackBar: () => dispatch(hideEqueuesSnackBar()),
    showEqueueSnackBar: () => {
      dispatch(showEqueuesSnackBar());
    },
    clearSlot: () => dispatch(selectSlot(null)),
    setEqueuesLoaderVisible: () => {
      dispatch(showQueuesLoader());
    },
    hideEqueuesLoader: () => dispatch(hideQueuesLoader()),
    setExceptionsEqueue: (times) => dispatch(setExceptionsAction(times)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EqueuesPanel);
// {
//     "bookId":"be3efa1a-1cb8-4fc0-b01b-692d5e1da3fd",
//     "esiaId":"1000415878",
//     "status":{
//         "statusCode":201,
//         "statusMessage":"Приглашаем Вас получить запрашиваемую государственную услугу"
//     },
//     "timeSlot": {
//         "slotId":
//         "6f4a908b-d733-4763-887b-f6f918a90324",
//             "serviceId":"10001000603",
//         "organizationId":"1.2.643.5.1.13.13.12.2.16.1179.0.66715",
//         "areaId":"0",
//         "visitTime":1611813600000,
//         "visitTimeStr":"2021-01-28T09:00:00.000",
//         "visitTimeISO":"2021-01-28T09:00:00.000",
//         "queueNumber":null,
//         "duration":null,
//         "attributes":[]
//     },
//     "error":null
// }
// {{ "hasMore":true,
//     "items":[{
//     "date":"2021-12-29T14:00:00.000+0300",
//     "data":{
//         "orderId":763575200,
//         "snippets":[{
//             "date":"2021-12-29T14:00:00.000+0300",
//             "orgName":"Женская консультация, ГАУЗ \"Городская поликлиника № 21\"",
//             "address":"Республика Татарстан, г.Казань, ул.Рихарда Зорге, д.103",
//             "comment":"В процессе передачи данных произошла ошибка, попробуйте подать заявление повторно.",
//             "localDate":"2021-12-29T14:00:00.000",
//             "type":"EQUEUE"
//         }],
//         "toDoctor":"Y"
//     },
//     "unread":false,
//     "hasQuiz":false,
//     "archive":false,
//     "title":"Запись подтверждена",
//     "ownerId":1000415878,
//     "userId":1000415878,
//     "subTitle":"на прием к врачу",
//     "hiddenEvents":false,
//     "feedType":"EQUEUE",
//     "id":9889394859,
//     "extId":"f4fa37be-6f0e-4cfd-9362-8d84b8860983",
//     "status":"done"
// }]}}
